export const smallCardIcon = 'https://assets.thdstatic.com/images/v1/payment-credit-card-thd.png';

export const largeCardImage = 'https://assets.thdstatic.com/images/v1/plcc-credit-card.png';
